import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmSupervisionType } from '../interfaces/IKnmSupervisionType';

export async function fetchKnmSupervisionTypes(isErp?: boolean): Promise<IKnmSupervisionType[]> {
  return apiGet<IKnmSupervisionType[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE, isErp)}/catalogs/knm-supervision-types`,
  );
}

export interface IFetchKnmSupervisionTypesByKnmTypeAndSubjectType {
  knmTypeId: number;
  subjectTypeId: number;
}

export async function fetchKnmSupervisionTypesByKnmTypeAndSubjectType({
  knmTypeId,
  subjectTypeId,
}: IFetchKnmSupervisionTypesByKnmTypeAndSubjectType): Promise<IKnmSupervisionType[]> {
  return apiGet<IKnmSupervisionType[]>(
    `${getServiceBaseURL(
      APIServiceEnum.BASE_SERVICE,
    )}/catalogs/knm-supervision-types/by-knm-type-and-subject-types/${knmTypeId}/${subjectTypeId}`,
  );
}

interface IFetchKnmSupervisionTypesByKnmTypeAndFederalLaw {
  knmTypeId: number;
  federalLawId: number;
}

export async function fetchKnmSupervisionTypesByKnmTypeAndFederalLaw({
  knmTypeId,
  federalLawId,
}: IFetchKnmSupervisionTypesByKnmTypeAndFederalLaw): Promise<IKnmSupervisionType[]> {
  return apiGet<IKnmSupervisionType[]>(
    `${getServiceBaseURL(
      APIServiceEnum.BASE_SERVICE,
    )}/catalogs/knm-supervision-types/by-knm-type-and-federal-law/${knmTypeId}/${federalLawId}`,
  );
}
